import { redirectToMyAccount } from "@repo/shared-utils/common-utils";
import { SSORedirectHandler } from "../../../../apps/web/app/components/ClickHandler/RedirectionConfig.interface";
import { store } from "@repo/web-store";

export const myAccountHandler: SSORedirectHandler = async (data) => {
  const url = data.mapping.newUrl;
  const { loginStatus = "failure" } = store?.getState()?.auth ?? {};
  if (data.mapping.ssoProduct?.[0])
    url.searchParams.set("Source", data.mapping.ssoProduct?.[0] || "");
  if (loginStatus !== "failure" && data.mapping.ssoFormPostUrl) {
    redirectToMyAccount(data.mapping.ssoFormPostUrl, url.toString());
  } else {
    window.open(url, data.target);
  }
};
